/* eslint-disable no-unused-vars */
import React, { useState } from 'react';
// import { Link as RouterLink } from 'react-router-dom';
// import { Link as RouterLink, useNavigate } from 'react-router-dom';
// import * as Yup from 'yup';
// import { Formik } from 'formik';
import {
  // Box,
  // Button,
  // Checkbox,
  Container,
  // FormHelperText,
  // Link,
  // TextField,
  // Typography,
  makeStyles,
  Grid
} from '@material-ui/core';
import Page from '../../components/Page';
import Navbar from '../GetStarted/Navbar';
import NavbarLower from '../GetStarted/NavbarLower';
import Footer from '../pages/Footer';
import MainMenu from '../GetStarted/MainMenu';
import { useNavigate } from 'react-router-dom';
const useStyles = makeStyles((theme) => ({
  stepContainer: {
    display: 'flex',
    width: '100%',
    maxWidth: '900px',
    margin: '0 auto',
    backgroundColor: 'white',
    padding: '20px',
    borderRadius: '10px',
    flexDirection: 'column', // Stack the navigation and content
  },
  stepNav: {
    display: 'flex',
    width: '100%',
    justifyContent: 'space-between',
    paddingRight: '20px',
    position: 'relative', // Set position relative for pseudo-element positioning
  },
  step: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: '0',
    color: '#b8c0cc',
    fontWeight: 'bold',
    padding: '10px',
    borderRadius: '5px',
    transition: 'background-color 0.3s, color 0.3s',
    cursor: 'pointer',
    position: 'relative', // Set position relative for pseudo-element positioning
    '&:hover': {
      backgroundColor: '#e6f0ff',
    },
    '&:not(:last-child)::after': { // Add line after each step except the last one
      content: "''",
      position: 'absolute',
      right: '-15px', // Adjust as necessary to position the line
      top: '50%', // Center the line vertically
      width: '30px', // Length of the line
      height: '2px', // Thickness of the line
      backgroundColor: '#b8c0cc', // Color of the line
      transform: 'translateY(-50%)', // Center the line vertically
    },
  },
  activeStep: {
    backgroundColor: '#0061f2',
    color: 'white',
    fontWeight: 'bold',
  },
  completedStep: {
    backgroundColor: '#c1e1ff',
    color: '#0061f2',
  },
  stepNumber: {
    width: '30px',
    height: '30px',
    backgroundColor: 'transparent', // Make the circle transparent
    color: 'inherit', // Use the current color
    border: '2px solid currentColor', // Use current color for the border
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginRight: '10px',
  },
  content: {
    marginTop: '20px', // Add some space between navigation and content
  },
  planSelection: {
    width: '70%',
    textAlign: 'center',
  },
  plans: {
    display: 'flex',
    justifyContent: 'space-around',
    marginBottom: '20px',
  },
  plan: {
    width: '120px',
    border: '2px solid #ccc',
    borderRadius: '10px',
    padding: '20px',
    textAlign: 'center',
    cursor: 'pointer',
    transition: 'border-color 0.3s',
    '&:hover': {
      borderColor: '#0061f2',
    },
  },
  selectedPlan: {
    borderColor: '#0061f2',
    backgroundColor: '#f0f8ff',
  },
  billingToggle: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: '20px',
  },
  switch: {
    position: 'relative',
    display: 'inline-block',
    width: '60px',
    height: '34px',
  },
  slider: {
    position: 'absolute',
    cursor: 'pointer',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: '#ccc',
    transition: '0.4s',
    borderRadius: '34px',
    '&:before': {
      position: 'absolute',
      content: '""',
      height: '26px',
      width: '26px',
      left: '4px',
      bottom: '4px',
      backgroundColor: 'white',
      transition: '0.4s',
      borderRadius: '50%',
    },
    '& input:checked + &': {
      backgroundColor: '#0061f2',
    },
    '& input:checked + &:before': {
      transform: 'translateX(26px)',
    },
  },
  navButtons: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  goBack: {
    backgroundColor: '#0061f2',
    color: 'white',
    border: 'none',
    padding: '10px 20px',
    borderRadius: '5px',
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: '#004bb5',
    },
  },
  nextStep: {
    backgroundColor: '#0061f2',
    color: 'white',
    border: 'none',
    padding: '10px 20px',
    borderRadius: '5px',
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: '#004bb5',
    },
  },
}));


export const GuaranteeForm = () => {
  const classes = useStyles();
  const [billing, setBilling] = useState('yearly');
  const [selectedPlan, setSelectedPlan] = useState(null);
  const [activeStep, setActiveStep] = useState(1); // Tracks the current active step

  const toggleBilling = () => {
    setBilling(billing === 'yearly' ? 'monthly' : 'yearly');
  };

  const handleSelectPlan = (plan) => {
    setSelectedPlan(plan);
  };

  const renderStepContent = () => {
    switch (activeStep) {
      case 1:
        return <div>Start Application content goes here.</div>;
      case 2:
        return <div>Fill the Application content goes here.</div>;
      case 3:
        return <div>Add-Ons content goes here.</div>;
      case 4:
        return <div>Summary content goes here.</div>;
      default:
        return null;
    }
  };

  return (
    <div>
      <NavbarLower />
      <div className={classes.stepContainer}>
        {/* Step navigation */}
        <div className={classes.stepNav}>
          <div className={`${classes.step} ${activeStep === 1 ? classes.activeStep : ''}`} onClick={() => setActiveStep(1)}>
            <span className={classes.stepNumber}>1</span> START APPLICATION
          </div>
          <div className={`${classes.step} ${activeStep === 2 ? classes.activeStep : ''}`} onClick={() => setActiveStep(2)}>
            <span className={classes.stepNumber}>2</span> Fill the Application
          </div>
          <div className={`${classes.step} ${activeStep === 3 ? classes.activeStep : ''}`} onClick={() => setActiveStep(3)}>
            <span className={classes.stepNumber}>3</span> ADD-ONS
          </div>
          <div className={`${classes.step} ${activeStep === 4 ? classes.activeStep : ''}`} onClick={() => setActiveStep(4)}>
            <span className={classes.stepNumber}>4</span> SUMMARY
          </div>
        </div>

        {/* Step content */}
        <div className={classes.stepContent}>
          {renderStepContent()}
        </div>

        {/* Navigation Buttons */}
        <div className={classes.navButtons}>
          {activeStep > 1 && (
            <button className={classes.goBack} onClick={() => setActiveStep(activeStep - 1)}>
              Go Back
            </button>
          )}
          {activeStep < 4 && (
            <button className={classes.nextStep} onClick={() => setActiveStep(activeStep + 1)}>
              Next Step
            </button>
          )}
        </div>
      </div>
      <Footer />
    </div>
  );
};
export default GuaranteeForm;
